<template>
  <div></div>
</template>

<script>
export default {
  async created() {
    await this.$store.dispatch("initializeApp");
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Login.vue